import i18next from 'i18next';

i18next.addResources('es_CL', 'NavLinkCallCenter', {
  newOrder: 'Nueva orden',
  orders: 'Mis ordenes',
  stores: 'Tiendas',
  logout: 'Cerrar Sesión'
});
